import {JAMS_PALETTE} from './consts'
import {DrawingStyle, Jam, LoadRouteActionTypes, Point, RoutePoints, RouteType} from './types'

export const isRoutePoints = (points: Point[]): points is RoutePoints => points.length >= 2

export const jamsToStyle = (jams: Jam[]): DrawingStyle => ({
  fillRule: 'nonzero',
  fill: '#333',
  fillOpacity: 0.9,
  stroke: [
    {
      width: 4,
      palette: jams.map(jam => ({color: JAMS_PALETTE[jam.type]?.color, count: jam.count})),
    },
    {
      width: 6,
      palette: jams.map(jam => ({
        color: JAMS_PALETTE[jam.type]?.border,
        count: jam.count,
      })),
    },
    {width: 10, color: '#fff'},
  ],
})

export const loadRoute = (points: Point[], {onBoundsChange}: LoadRouteActionTypes) =>
  new Promise<RouteType | null>((resolve, reject) => {
    const isRouteAvailable = isRoutePoints(points)
    if (isRouteAvailable) {
      ymaps3
        // TODO выпилить когда карты завезут свою реализацию CARGODEV-23652
        // @ts-expect-error маршруты находятся в разработке у карт, типов для них еще нет
        .route({type: 'driving', points, jams: true, bounds: true})
        .then((routes: {toRoute: () => RouteType}[]) => {
          const route = routes[0]?.toRoute?.()
          if (!route) {
            return reject('route not found')
          }
          if (onBoundsChange) {
            onBoundsChange({bounds: route.properties.bounds, duration: 300})
          }
          resolve(route)
        })
        .catch(reject)
    } else {
      resolve(null)
    }
  })
